export default __webpack_public_path__ + "static/METALLIC LAMINATE-647b7e11d6b92d8d3cfe36d783515739.webp";